import React from 'react'
import * as S from './ReceivementHeader.styles'

interface Props {
    title: string | React.ReactNode;
    headerButton?: React.ReactNode;
}

const ReceivementHeader = ({ title, headerButton }: Props) => (
  <S.HeaderWrapper>
    {title}
    {headerButton}
  </S.HeaderWrapper>
)

export { ReceivementHeader }
